import type { SyntaxNode } from 'web-tree-sitter';
import { resolveImportSourcePath } from '../../resolve-module-import-path.js';
import type { SymbolImportBinding, SymbolImportKind } from '../../types.js';

export function pushBinding(
  out: SymbolImportBinding[],
  filePath: string,
  workspaceFiles: ReadonlySet<string>,
  moduleSpecifier: string,
  localName: string,
  sourceName: string,
  importKind: SymbolImportKind,
  nameNode: SyntaxNode,
): void {
  if (!localName) return;
  out.push({
    localName,
    sourceName,
    moduleSpecifier,
    sourceFilePath: resolveImportSourcePath(filePath, moduleSpecifier, workspaceFiles),
    importKind,
    startLine: nameNode.startPosition.row,
    startColumn: nameNode.startPosition.column,
  });
}

export function stripQuotes(text: string): string {
  const trimmed = text.trim();
  if (
    (trimmed.startsWith('"') && trimmed.endsWith('"')) ||
    (trimmed.startsWith("'") && trimmed.endsWith("'"))
  ) {
    return trimmed.slice(1, -1);
  }
  return trimmed;
}

export function stringLiteralText(node: SyntaxNode): string {
  const fragment = node.descendantsOfType('string_fragment')[0];
  return stripQuotes(fragment?.text ?? node.text);
}
